import React from 'react';
import upperFirst from 'mn-utils/upperFirst';
import formatTime from 'mn-utils/formatTime';
import Ripple from '../../../dumb/Ripple';
import ResendMoneyIcon from '../../../icons/ResendMoney';
import * as links from '../../../../constants/links';
import RefreshIcon from '@material-ui/icons/Refresh';
import LayoutA from '../../../dumb/Layout/A';
import Caption from '../../../dumb/Caption/A';
import HeaderA from '../../../dumb/Header/A';
import ButtonUp from '../../../dumb/Button/Up';
import Tooltip from '../../../dumb/Tooltip/A';
import RowA from '../../../dumb/Row/A';
import ColA from '../../../dumb/Col/A';
import ColA2 from '../../../dumb/Col/A2';
import RowB from '../../../dumb/Row/B';
import ColB from '../../../dumb/Col/B';
import ColB2 from '../../../dumb/Col/B2';
import WrapperWithLoading from '../../../dumb/WrapperWithLoading';
import ButtonD from '../../../dumb/Button/D';
import InfoIcon from '../../../icons/Info';
import virtualOutputComponentProvider from '../../../../utils/virtualOutputComponentProvider';
import {
  apiAdminPayoutGroupList,
} from '../../../../api/admin/payout/nium';
import {
  Link,
  pushLocation,
  replaceLocation,
} from '../../../../router';
import {
  openV1PopupInfo,
} from '../../../../emitters/popup';

const {
  DisplayIdAdmin,
  DisplayAmountAdmin,
  DisplayDateTimeAdmin
} = require("../../../dumb/DisplayData");

const FLOW_NIUM = 'v3_via_nium_direct';
const FLOW_VERTO = 'v2_via_verto_direct';
const FLOW_MAP = {
  [FLOW_NIUM]: 'NIUM',
  [FLOW_VERTO]: 'VERTO',
};

const STATUS_MAP = {
  'FundsRequested': 'Funds requested',
  'FundsReceivedByNium': 'Funds received by Nium',
  'FailedToTransferFunds': 'Failed to transfer funds',
  'PayoutsInProcess': 'Payouts in process',
  'Complete': 'Complete',
  'Canceled': 'Canceled',
};

const STATUS_CLASS_MAP = {
  FundsRequested: 'fr',
  FundsReceivedByNium: 'frbn',
  PayoutsInProcess: 'pip',
  Complete: 'cm',
  FailedToTransferFunds: 'fttf',
  Canceled: 'cn',
};

module.exports = virtualOutputComponentProvider({
  rowHeight: 70,
  request: apiAdminPayoutGroupList,
  wrapper(render, setState, self) {
    const getPayoutLink = function(name, flow) {
      const linkName = `LINK_ADMIN_PAYOUT_${FLOW_MAP[flow]}_${name}`;
      return links[linkName];
    };

    function Item({data}) {
      const id = data.id || '';
      const withdrawalDate = data.created_at || null;
      const amount = data.amount || '';

      const flow = data.flow;
      const flowDetails = data.flow_details;
      const payouts = flowDetails.payouts || [];

      const groupPlan = flowDetails.group_plan || {};
      const currency = groupPlan.payout_currency || '';

      const date = formatTime(withdrawalDate, '{dd} {mmm}, {yyyy}');
      const time = formatTime(withdrawalDate, '{hh}:{MM}:{ss} {TT}');

      const status = data.status;

      const icon = (<InfoIcon className="dB-i f46-i mhA w50 h50"/>);
      const info = (<>
        <div className="f22">{amount} {currency}</div>
        <div className="f18 mb20">{date} {time}</div>
      </>);
      const msg = (
        payouts.map((payout) => {
          const merchant = payout.merchant_name || payout.merchant_email || payout.merchant_id;

          return (
            <div key={payout.merchant_id} className="f16 mt10">
              {merchant}: <b>{payout.amount} {payout.currency}</b>
            </div>
          );
        })
      );

      return (<Ripple
        component={Link}
        className="olN tdN dB w cF dn bgF.03:h"
        onClick={() => {
          replaceLocation({
            path: `${getPayoutLink('GROUP_INFO', flow)}/${id}`,
          });
        }}
      >
        <RowA className="f12">
          <ColA className="wmin130 fx1">
            <DisplayIdAdmin>{id}</DisplayIdAdmin>
          </ColA>
          <ColA className="wmin97">
            {FLOW_MAP[flow]}
          </ColA>
          <ColA className="wmin147">
            <DisplayDateTimeAdmin date={withdrawalDate} />
          </ColA>
          <ColA className="wmin130 fx1">
            <DisplayAmountAdmin
              amount={amount}
              symbol={currency}
              type="fiat"
            />
          </ColA>
          <ColA className="wmin130 fx1">
            <Tooltip title={STATUS_MAP[status] || status}>
              <span className={'(c8E7CFF).fr (cFFBF43).frbn (c43FFE5).pip (c2CE889).cm (cF29696).fttf (cEE4F4F).cn '
              + STATUS_CLASS_MAP[status] || status
              }>
                {STATUS_MAP[status] || upperFirst(status)}
              </span>
            </Tooltip>
          </ColA>
          <ColA2 className="w50">
            <Tooltip title="Resend" disabledCopy>
              <Ripple
                className="w42 ыh42 p7 r7 (bgc0.25):h"
                onClick={() => {
                  const path = `${getPayoutLink('TRANSACTION_ADD', flow)}/${id}/${currency}`;
                  pushLocation({path});
                }}
              >
                <ResendMoneyIcon />
              </Ripple>
            </Tooltip>
          </ColA2>
          <ColA2 className="w50">
            <Tooltip title="Info" disabledCopy>
              <Ripple
                className="w42 h42 p7 r7 (bgc0.25):h"
                onClick={() => {
                  openV1PopupInfo([info, msg, icon]);
                }}
              >
                <InfoIcon />
              </Ripple>
            </Tooltip>
          </ColA2>
        </RowA>
      </Ripple>);
    }

    return (state) => {
      return (
        <LayoutA>
          <HeaderA>
            <Caption>Payout groups</Caption>

            <div className="layoutRow fhaS fvaC">
              <WrapperWithLoading
                loading={state.loading}
              >
                <ButtonD
                  className="wmin100"
                  onClick={self.update}
                >
                  <RefreshIcon/>
                  <div className="pl15">Refresh</div>
                </ButtonD>
              </WrapperWithLoading>
            </div>
          </HeaderA>

          <div className="abs st70 sh-45 sb10 ov">
            <div className="ovxA abs s ph45">
              <div className="wmin850 rlv h">
                <RowB className="f14">
                  <ColB className="wmin155 fx1">ID</ColB>
                  <ColB className="wmin97">Exchange</ColB>
                  <ColB className="wmin147">Withdrawal Date</ColB>
                  <ColB className="wmin130 fx1">Amount</ColB>
                  <ColB className="wmin130 fx1">Status</ColB>
                  <ColB2 className="w50"/>
                  <ColB2 className="w50"/>
                </RowB>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
          </div>
        </LayoutA>
      );
    };
  },
}, {});
